// IMPORTANTE: Configuração com as chaves Stripe reais
// Public key: pk_live_51O85t5BICvnzUZeSk33XcOh05q5lEXqbfjtUqExXTMqragrwfWlbaURYjco010dbTQHTGqTUtKjDSzeZeEuqpPle007JfyJA3R
// Secret key: STRIPE_SECRET_KEY env variable (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)

export const STRIPE_PUBLIC_KEY = 'pk_live_51O85t5BICvnzUZeSk33XcOh05q5lEXqbfjtUqExXTMqragrwfWlbaURYjco010dbTQHTGqTUtKjDSzeZeEuqpPle007JfyJA3R';

export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  mode: 'payment' | 'subscription';
  price: number;
  currency: string;
  interval?: 'month' | 'year';
  duration?: number; // Duration in days for one-time purchases
  features?: string[]; // Array de funcionalidades extras
}

// Configuração com preços fixos para evitar o erro "Missing required parameter price_id"
export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'prod_annual',
    // ID do preço anual de $19,99
    priceId: 'price_1Rk98MBICvnzUZeSjGqf0lLA', // Preço anual real
    name: 'Premium Annual Access',
    description: '12-month access to all premium templates with customization options for logos and branding',
    mode: 'subscription',
    price: 19.99,
    currency: 'USD', 
    interval: 'year',
    features: [
      'Acesso a todos os templates premium',
      'Remoção de marca d\'água',
      'Cabeçalhos e rodapés personalizados',
      'Suporte para anexos',
      'Suporte para múltiplas moedas',
      'Assinatura digital',
      'Imagens nos itens',
      'Atualizações de templates gratuitas'
    ]
  },
  {
    id: 'prod_monthly',
    // ID do preço mensal de $7,99
    priceId: 'price_1Rk96xBICvnzUZeS289jD55r', // Preço mensal real
    name: 'Premium Monthly Access',
    description: '30-day access to all premium templates with customization options',
    mode: 'subscription',
    price: 7.99,
    currency: 'USD',
    interval: 'month',
    features: [
      'Acesso a todos os templates premium',
      'Remoção de marca d\'água',
      'Cabeçalhos e rodapés personalizados',
      'Suporte para múltiplas moedas'
    ]
  },
  {
    id: 'prod_single_template',
    // Preço para template individual - Usando modo subscription já que o preço parece ser recurring
    priceId: 'price_1Rk95pBICvnzUZeSUfbjhprN', // Preço base para templates individuais ($1.00)
    name: 'Single Template Access',
    description: 'Access to a single template for 8 days',
    mode: 'subscription',
    price: 1.00, // Preço base para templates individuais
    currency: 'USD',
    interval: 'month', // Usando intervalo de 1 mês
    duration: 8, // 8 days access
    features: [
      'Tipografia moderna',
      'Logo personalizado',
      'Campos personalizáveis'
    ]
  },
  // Template específico - Emerald Professional $1.00
  {
    id: 'template_emerald_pro',
    priceId: 'price_1Rk95pBICvnzUZeSUfbjhprN', // Preço recurring
    name: 'Emerald Professional Template',
    description: 'Access to Emerald Professional template for 8 days',
    mode: 'subscription',
    price: 1.00,
    currency: 'USD',
    interval: 'month',
    duration: 8
  },
  // Template específico - Sunset Creative $1.00
  {
    id: 'template_sunset_creative',
    priceId: 'price_1Rk95pBICvnzUZeSUfbjhprN', // Preço recurring
    name: 'Sunset Creative Template',
    description: 'Access to Sunset Creative template for 8 days',
    mode: 'subscription',
    price: 1.00,
    currency: 'USD',
    interval: 'month',
    duration: 8
  },
  // Template específico - Purple Luxury $1.00
  {
    id: 'template_purple_luxury',
    priceId: 'price_1Rk95pBICvnzUZeSUfbjhprN', // Preço recurring
    name: 'Purple Luxury Template',
    description: 'Access to Purple Luxury template for 8 days',
    mode: 'subscription',
    price: 1.00,
    currency: 'USD',
    interval: 'month',
    duration: 8
  },
  // Template específico - Rose Elegant $1.00
  {
    id: 'template_rose_elegant',
    priceId: 'price_1Rk95pBICvnzUZeSUfbjhprN', // Preço recurring
    name: 'Rose Elegant Template',
    description: 'Access to Rose Elegant template for 8 days',
    mode: 'subscription',
    price: 1.00,
    currency: 'USD',
    interval: 'month',
    duration: 8
  },
  // Template específico - Teal Modern $1.00
  {
    id: 'template_teal_modern',
    priceId: 'price_1Rk95pBICvnzUZeSUfbjhprN', // Preço recurring
    name: 'Teal Modern Template',
    description: 'Access to Teal Modern template for 8 days',
    mode: 'subscription',
    price: 1.00,
    currency: 'USD',
    interval: 'month',
    duration: 8
  },
  // Template específico - Amber Warm $1.00
  {
    id: 'template_amber_warm',
    priceId: 'price_1Rk95pBICvnzUZeSUfbjhprN', // Preço recurring
    name: 'Amber Warm Template',
    description: 'Access to Amber Warm template for 8 days',
    mode: 'subscription',
    price: 1.00,
    currency: 'USD',
    interval: 'month',
    duration: 8
  },
  // Template específico - Indigo Corporate $1.00
  {
    id: 'template_indigo_corporate',
    priceId: 'price_1Rk95pBICvnzUZeSUfbjhprN', // Preço recurring
    name: 'Indigo Corporate Template',
    description: 'Access to Indigo Corporate template for 8 days',
    mode: 'subscription',
    price: 1.00,
    currency: 'USD',
    interval: 'month',
    duration: 8
  },
  // Template específico - Slate Minimal $1.00
  {
    id: 'template_slate_minimal',
    priceId: 'price_1Rk95pBICvnzUZeSUfbjhprN', // Preço recurring
    name: 'Slate Minimal Template',
    description: 'Access to Slate Minimal template for 8 days',
    mode: 'subscription',
    price: 1.00,
    currency: 'USD',
    interval: 'month',
    duration: 8
  },
  // Template específico - Premium + Logo $1.00
  {
    id: 'template_premium_logo',
    priceId: 'price_1Rk95pBICvnzUZeSUfbjhprN', // Preço recurring
    name: 'Premium + Logo Template',
    description: 'Access to Premium + Logo template for 8 days',
    mode: 'subscription',
    price: 1.00,
    currency: 'USD',
    interval: 'month',
    duration: 8
  },
  {
    id: 'prod_premium_template',
    priceId: 'price_1Rk95pBICvnzUZeSUfbjhprN', // Preço recurring
    name: 'Premium Template Access',
    description: 'Access to a premium template for 8 days',
    mode: 'subscription',
    price: 1.00, // Preço para templates premium
    currency: 'USD',
    interval: 'month',
    duration: 8
  },
  {
    id: 'prod_exclusive_template',
    priceId: 'price_1Rk95pBICvnzUZeSUfbjhprN', // Preço recurring
    name: 'Exclusive Template Access',
    description: 'Access to an exclusive template for 8 days',
    mode: 'subscription',
    price: 1.00, // Preço para templates exclusivos
    currency: 'USD',
    interval: 'month',
    duration: 8
  }
];

export const getProductById = (id: string): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product => product.id === id);
};

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product => product.priceId === priceId);
};

// Get a product that matches a template ID
export const getProductForTemplateId = (templateId: string): StripeProduct | undefined => {
  const templateProductId = `template_${templateId}`;
  return STRIPE_PRODUCTS.find(product => product.id === templateProductId) || 
         STRIPE_PRODUCTS.find(product => product.id === 'prod_single_template');
};